import React from 'react';

const steps = [
  {
    number: '01',
    title: 'Discovery & Strategy',
    description: 'We begin by deeply understanding your vision, target audience, and market opportunity. Through collaborative workshops, we define the product strategy, user personas, and success metrics that will guide development.',
    details: ['Market Research', 'User Personas', 'Product Roadmap', 'Technical Feasibility'],
  },
  {
    number: '02',
    title: 'Design & Prototype',
    description: 'Our design process puts users at the centre. We create wireframes, interactive prototypes, and polished UI designs. Every interaction is tested with real users before a single line of code is written.',
    details: ['UX Wireframes', 'UI Design System', 'Interactive Prototypes', 'User Testing'],
  },
  {
    number: '03',
    title: 'Develop & Integrate',
    description: 'Using agile methodology, we build your app in iterative sprints. Native iOS and Android development runs in parallel with AWS backend services, AI model integration, and rigorous automated testing.',
    details: ['Native Development', 'AWS Backend', 'AI Integration', 'Automated Testing'],
  },
  {
    number: '04',
    title: 'Launch & Grow',
    description: 'We handle App Store and Google Play submissions, configure monitoring and analytics, and provide ongoing support. Post-launch, we analyse user data to continuously improve and grow your application.',
    details: ['Store Submission', 'Performance Monitoring', 'Analytics Setup', 'Continuous Improvement'],
  },
];

const Process = () => {
  return (
    <section id="process" className="process section">
      <div className="container">
        <div className="section__header">
          <span className="section__tag">Our Process</span>
          <h2 className="section__title">
            From Idea to
            <span className="gradient-text"> App Store</span>
          </h2>
          <p className="section__subtitle">
            A proven four-stage process that transforms your concept into a
            polished, market-ready mobile application.
          </p>
        </div>

        <div className="process__timeline">
          {steps.map((step, index) => (
            <div key={index} className="process__step">
              <div className="process__step-marker">
                <span className="process__step-number">{step.number}</span>
                {index < steps.length - 1 && <div className="process__step-line" />}
              </div>
              <div className="process__step-content">
                <h3 className="process__step-title">{step.title}</h3>
                <p className="process__step-desc">{step.description}</p>
                <div className="process__step-details">
                  {step.details.map((detail, i) => (
                    <span key={i} className="process__step-tag">{detail}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
